import { Box, Center, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const steps = [
  { number: 1, titleKey: 'registration.step1Title', descKey: 'registration.step1Desc' },
  { number: 2, titleKey: 'registration.step2Title', descKey: 'registration.step2Desc' },
  { number: 3, titleKey: 'registration.step3Title', descKey: 'registration.step3Desc' }
] as const;

export const RegisterHero = () => {
  const { t } = useTranslation();

  return (
    <Box
      w={{ base: '100%', md: 440 }}
      p={{ base: 24, md: 40 }}
      style={{
        borderRadius: 12,
        backgroundColor: 'var(--color-bg-surface-2)',
        border: '1px solid var(--color-border-default)'
      }}
    >
      <Stack gap={20}>
        <Stack gap={2}>
          <Text
            fz={{ base: 26, md: 34 }}
            lh={{ base: 1.23, md: 1.18 }}
            fw={700}
            style={{ color: 'var(--color-text-primary)' }}
          >
            {t('registration.heroLine1')}
          </Text>
          <Text
            fz={{ base: 26, md: 34 }}
            lh={{ base: 1.23, md: 1.18 }}
            fw={700}
            style={{ color: 'var(--color-accent-primary-active)' }}
          >
            {t('registration.heroLine2')}
          </Text>
        </Stack>
        <Text fz={13} lh="19px" style={{ color: 'var(--color-text-secondary)' }}>
          {t('registration.heroSubtitle')}
        </Text>

        <Stack gap={0} py={4}>
          {steps.map((step, index) => (
            <Box key={step.number} style={{ display: 'flex', gap: 16 }}>
              <Stack gap={0} align="center" w={30} style={{ flexShrink: 0 }}>
                <Center
                  w={30}
                  h={30}
                  style={{
                    borderRadius: 999,
                    backgroundColor: 'var(--color-bg-surface)',
                    border:
                      index === 0
                        ? '2px solid var(--color-accent-primary)'
                        : '1.5px solid var(--color-border-soft)',
                    flexShrink: 0
                  }}
                >
                  <Text
                    fz={11}
                    fw={600}
                    style={{
                      letterSpacing: 0.4,
                      color:
                        index === 0
                          ? 'var(--color-accent-primary-active)'
                          : 'var(--color-text-secondary)'
                    }}
                  >
                    {step.number}
                  </Text>
                </Center>
                {index < steps.length - 1 && (
                  <Box w={2} style={{ flex: 1, backgroundColor: 'var(--color-border-soft)' }} />
                )}
              </Stack>
              <Stack gap={6} pt={2} pb={index < steps.length - 1 ? 24 : 0}>
                <Text fz={14} fw={600} lh="20px" style={{ color: 'var(--color-text-primary)' }}>
                  {t(step.titleKey)}
                </Text>
                <Text fz={13} lh="19px" style={{ color: 'var(--color-text-secondary)' }}>
                  {t(step.descKey)}
                </Text>
              </Stack>
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
